// WeBeauty 首页滚动动效,桌面和手机同一套逻辑:跟随滚动,进入淡入,往回滚淡出。
//
// Every [data-reveal] element has a target (0 -> 1, from where it sits in the viewport) and a
// current value that eases toward the target, so motion keeps settling after the scroll stops.
// Only opacity and transform are written, so layout never moves.
// The loop only runs while something is still settling; an idle page does no work.
//
// Layout position = measured top minus the translateY this file wrote. Reading the transformed
// box directly would make the position depend on its own animation.
//
// Same-row cards start later by column. Columns are read from the real layout, so a stacked
// phone layout gets no stagger with no special case. A heading beside its cards goes first.
//
// THREE RULES THIS FILE MUST NEVER BREAK
//   1. Binding is idempotent and RE-RUNNABLE. The host re-renders the template, which
//      replaces the section nodes. Anything that latches after the first pass leaves the
//      observer watching detached nodes while the live ones stay hidden forever.
//   2. The hiding class goes on only AFTER at least one live node is observed, and it is
//      removed the moment nothing is being watched.
//   3. A watchdog releases anything still hidden and unmeasured once it is on screen
//      (or scrolled past) for 1.5s. Content visibility must never depend on an observer
//      firing. What is still below the fold is not stuck, only not reached yet: it keeps
//      waiting and is re-checked every second by position, not by observer.
//
// findScroller is load-bearing on Shopify: the theme scrolls .page-wrapper on desktop and
// the window on phones.
(function () {
  var REDUCE = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  // re-entry from a second evaluation just re-binds against the current DOM
  if (window.__wbReveal && window.__wbReveal.rebind) { window.__wbReveal.rebind(); return; }

  // 默认值和主题设置「WB motion」的默认值一致。脚本标签上的 data-* 由主题设置输出。
  var conf = document.getElementById('wb-scroll-reveal');
  var data = conf ? conf.dataset : {};
  function num(v, fallback) { var n = parseFloat(v); return isNaN(n) ? fallback : n; }
  var SETTLE_MS = num(data.settle, 550);
  var DISTANCE = num(data.distance, 56);
  var STAGGER = num(data.stagger, 7) / 100;
  var TAU = SETTLE_MS / 6000;  // 指数追随的时间常数:约 6 个 TAU 到位
  var FULL_AT = 0.3;           // 元素顶部到屏幕从上往下 30% 处完全显示
  var SNAP = 0.002;            // 差这么多就直接到位,56px 下约 0.1px

  document.documentElement.style.setProperty('--wb-motion-distance', DISTANCE + 'px');

  var states = new Map();      // element -> { el, p, t, y, col, lead, first, off }
  var near = [];               // states currently near the viewport
  var proxied = new Map();     // horizontal scroller -> states of the cards inside it
  var seen = new WeakSet();    // nodes already handed to the observer
  var touched = new WeakSet(); // nodes this file has measured at least once
  var raf = 0, last = 0, dirty = false, tail = 0, width = 0;
  var io = null, watchdog = 0, observing = 0, scroller = null, listening = false;

  function clamp01(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }

  function release(el) {
    el.style.opacity = '';
    el.style.transform = '';
    el.style.willChange = '';
    el.setAttribute('data-reveal', '1');
  }
  function showAll(els) { for (var i = 0; i < els.length; i++) release(els[i]); }

  function hideClass(on) {
    document.documentElement.classList[on ? 'add' : 'remove']('js-reveal');
  }

  function paint(s, moving) {
    var el = s.el;
    if (s.p >= 1) {
      s.y = 0;
      if (el.getAttribute('data-reveal') !== '1') release(el);
      return;
    }
    if (el.getAttribute('data-reveal') !== '0') el.setAttribute('data-reveal', '0');
    s.y = (1 - s.p) * DISTANCE;
    el.style.opacity = s.p.toFixed(3);
    el.style.transform = 'translateY(' + s.y.toFixed(2) + 'px)';
    el.style.willChange = moving ? 'opacity, transform' : '';
  }

  // Read-only: where each near element should be for the current scroll position.
  function measure() {
    var vh = window.innerHeight;
    var sc = scroller || document.scrollingElement || document.documentElement;
    var left = sc.scrollHeight - sc.clientHeight - sc.scrollTop; // scroll distance still available
    for (var i = near.length - 1; i >= 0; i--) {
      var s = near[i];
      if (!s.el.isConnected) { near.splice(i, 1); continue; }
      var r = s.el.getBoundingClientRect();
      var top = r.top - s.y;
      var off = r.bottom - s.y < 0 || top > vh;
      if (s.lead) top = Math.max(top, s.lead.el.getBoundingClientRect().top - s.lead.y);
      var shift = s.col * STAGGER * vh;
      var start = vh - shift;
      // near the page end an element may never reach its line: finish where it can get to
      var stop = Math.max(vh * FULL_AT - shift, top - left);
      s.t = stop >= start ? 1 : clamp01((start - top) / (start - stop));
      s.off = off;
    }
  }

  function frame(now) {
    raf = 0;
    if (dirty) { dirty = false; measure(); }

    var dt = last ? Math.min(now - last, 100) / 1000 : 1 / 60;
    var k = TAU > 0 ? 1 - Math.exp(-dt / TAU) : 1;
    var moving = false;
    for (var i = 0; i < near.length; i++) {
      var s = near[i], was = s.p;
      if (s.first || s.off) s.p = s.t;   // first measure or off screen: nobody sees it, no easing
      else {
        s.p += (s.t - s.p) * k;
        if (Math.abs(s.t - s.p) < SNAP) s.p = s.t;
      }
      var settling = s.p !== s.t;
      if (s.first || was !== s.p || !settling) paint(s, settling);
      if (s.first) { s.first = false; touched.add(s.el); }
      if (settling) moving = true;
    }
    if (moving) { last = now; request(); }
    else last = 0;
  }

  function request() { if (!raf) raf = requestAnimationFrame(frame); }

  function onScroll() {
    dirty = true;
    request();
    // the host's scroll may be animated, so the last event can fire before motion stops:
    // guarantee one more measure at the true final position
    clearTimeout(tail);
    tail = setTimeout(function () { dirty = true; request(); }, 140);
  }

  // Column of each card, from the real layout. Earlier cards in the same section that share
  // this card's row push it one column later. A heading beside the cards goes first.
  function layoutCols() {
    var groups = new Map();
    states.forEach(function (s) {
      if (!s.el.isConnected) { states.delete(s.el); return; }
      var r = s.el.getBoundingClientRect();
      s.top = r.top - s.y;
      s.bottom = r.bottom - s.y;
      // 横向轮播里滑到屏幕外的卡:不算进同排的列数,自己也按第 0 列
      s.offX = r.right <= 0 || r.left >= window.innerWidth;
      var g = s.el.closest('.wb-sec') || s.el;
      if (!groups.has(g)) groups.set(g, []);
      groups.get(g).push(s);
    });
    function sameRow(a, b) { return a.top < b.bottom - 1 && b.top < a.bottom - 1; }
    groups.forEach(function (list) {
      var head = null, items = [];
      list.forEach(function (s) {
        if (s.el.hasAttribute('data-reveal-head')) head = s;
        else items.push(s);
      });
      if (head) head.col = 0;
      var after = head && items.length && sameRow(head, items[0]) ? 1 : 0;
      items.forEach(function (s, i) {
        var col = 0;
        if (!s.offX) for (var j = 0; j < i; j++) if (!items[j].offX && sameRow(items[j], s)) col++;
        s.col = col + after;
        s.lead = after ? head : null;   // never ahead of a heading that sits beside it
      });
    });
    width = window.innerWidth;
  }

  function onResize() {
    if (window.innerWidth !== width) {   // a phone's address bar changes the height only
      scroller = findScroller();
      layoutCols();
    }
    onScroll();
  }

  // Nothing may stay invisible. Anything still at data-reveal="0" that was never measured,
  // and that is already on screen or above it, gets released outright, and since that means
  // the observer failed, the hiding class goes with it. Anything below the fold has simply
  // not been reached. Box sizes are read directly, so this never waits on an observer.
  function check() {
    var stuck = document.querySelectorAll('[data-reveal="0"]'), any = false, waiting = false;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    for (var i = 0; i < stuck.length; i++) {
      var el = stuck[i];
      if (touched.has(el)) continue;
      var r = el.getBoundingClientRect();
      if (!r.width && !r.height) { release(el); continue; }   // not rendered: no evidence either way
      if (r.top < vh * 0.9) { release(el); any = true; }      // on screen or scrolled past, never measured
      else waiting = true;                                    // below the fold: not reached yet
    }
    if (any || !observing) hideClass(false);
    else if (waiting) watchdog = setTimeout(check, 1000);
  }
  function arm() {
    clearTimeout(watchdog);
    watchdog = setTimeout(check, 1500);
  }

  // Idempotent: safe to call on every mutation. Only NEW nodes are bound.
  function bind() {
    var els = document.querySelectorAll('[data-reveal]');
    if (!els.length) { hideClass(false); return; }

    // reduced motion or no IO -> content simply visible, never hidden
    if (REDUCE || !window.IntersectionObserver) { hideClass(false); showAll(els); return; }

    var i, fresh = [];
    for (i = 0; i < els.length; i++) {
      if (seen.has(els[i])) continue;
      seen.add(els[i]);
      if (els[i].getAttribute('data-reveal') === '0') fresh.push(els[i]);
    }
    if (!fresh.length) { arm(); return; }

    if (!io) {
      io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          // 横向轮播里的卡观察的是整条轮播:横向滑出去不算离开,淡入只看竖直位置
          var list = proxied.get(e.target) || [states.get(e.target)];
          list.forEach(function (s) {
            if (!s) return;
            var at = near.indexOf(s);
            if (e.isIntersecting) { if (at < 0) near.push(s); }
            else {
              if (at >= 0) near.splice(at, 1);
              // left the watch zone, or a jump skipped over it: rest at the matching end
              s.p = s.t = e.boundingClientRect.bottom < 0 ? 1 : 0;
              s.first = false;
              touched.add(s.el);
              paint(s, false);
            }
          });
        });
        dirty = true;
        request();
      }, { rootMargin: '200px 0px' });
    }

    var hidden = document.documentElement.classList.contains('js-reveal');
    for (i = 0; i < fresh.length; i++) {
      states.set(fresh[i], { el: fresh[i], p: 0, t: 0, y: hidden ? DISTANCE : 0, col: 0, first: true, off: false });
    }
    layoutCols();
    for (i = 0; i < fresh.length; i++) {
      var scroller = fresh[i].closest('.wb-creators__track');
      if (scroller) {
        if (!proxied.has(scroller)) { proxied.set(scroller, []); io.observe(scroller); }
        proxied.get(scroller).push(states.get(fresh[i]));
      } else {
        io.observe(fresh[i]);
      }
      observing++;
    }

    // only hide once something live is actually being watched
    hideClass(true);
    for (i = 0; i < fresh.length; i++) states.get(fresh[i]).y = DISTANCE;

    if (!listening) {
      listening = true;
      scroller = findScroller();
      window.addEventListener('scroll', onScroll, { passive: true });
      document.addEventListener('scroll', onScroll, { passive: true, capture: true });
      window.addEventListener('resize', onResize);
      window.addEventListener('load', function () { layoutCols(); onScroll(); });
    }
    arm();
  }

  function findScroller() {
    var el = document.querySelector('[data-reveal]');
    for (var n = el && el.parentElement; n && n !== document.body; n = n.parentElement) {
      var o = getComputedStyle(n).overflowY;
      if ((o === 'auto' || o === 'scroll') && n.scrollHeight > n.clientHeight + 4) return n;
    }
    return document.scrollingElement || document.documentElement;
  }

  window.__wbReveal = { rebind: bind };

  // A re-render swaps the section nodes out. Re-bind against whatever is on screen now.
  var pending = 0;
  if (window.MutationObserver) {
    new MutationObserver(function () {
      clearTimeout(pending);
      pending = setTimeout(bind, 60);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  bind();
  // the template may still be streaming: keep looking for sections for a few seconds
  var tries = 0;
  var timer = setInterval(function () { bind(); if (++tries > 24) clearInterval(timer); }, 200);
})();
